import React from "react";
import HandlePerfectRelics from "../Handle/HandlePerfectRelics";

function PerfectRelics() {
  return <HandlePerfectRelics />;
}

export default PerfectRelics;
